module.exports = __webpack_public_path__ + "img/en-gb.e5da90d9.svg";